export default __webpack_public_path__ + "static/media/courses-hero.a65e6f9e.png";